import script from "./EmployeeDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeDetail.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeDetail.vue?vue&type=style&index=0&id=7e39da64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e39da64"]])

export default __exports__